import React from 'react';
import { useQueryClient } from '@tanstack/react-query';
import qs from 'qs';
import { join, repeat } from 'ramda';
import { DatevSettings } from 'utils/apiClient/services/datev/types';
import Login from './views/LoginView';
import config from '../config';

const { appDetails } = config;

const DatevLogin: React.FC = () => {
  const queryClient = useQueryClient();
  const datevSettings: DatevSettings | undefined = queryClient.getQueryData([
    'datev',
    'redirect_params',
  ]);
  const params =
    datevSettings &&
    qs.stringify(
      {
        state: join('', repeat('0', 21)),
        response_type: 'code id_token',
        scope: datevSettings.datev_scopes.join(' '),
        client_id: datevSettings.client_id,
        redirect_uri: appDetails.redirectUrl,
        nonce: datevSettings.nonce,
        code_challenge: datevSettings.code_challenge,
        code_challenge_method: 'S256',
      },
      { addQueryPrefix: true }
    );

  const datevOauthUri =
    datevSettings && `${datevSettings.auth_server}${params}`;

  return <Login datevOauthUri={datevOauthUri ?? ''} />;
};
export default DatevLogin;
